/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedWabaRouteImport } from './routes/_authed/waba'
import { Route as AuthedTarefasRouteImport } from './routes/_authed/tarefas'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedSelfServiceRouteImport } from './routes/_authed/self-service'
import { Route as AuthedReportsRouteImport } from './routes/_authed/reports'
import { Route as AuthedPatiooRouteImport } from './routes/_authed/patioo'
import { Route as AuthedFinanceiroRouteImport } from './routes/_authed/financeiro'
import { Route as AuthedEstoqueRouteImport } from './routes/_authed/estoque'
import { Route as AuthedDevRouteImport } from './routes/_authed/dev'
import { Route as AuthedAgentsRouteImport } from './routes/_authed/agents'
import { Route as AuthedWikiIndexRouteImport } from './routes/_authed/wiki/index'
import { Route as AuthedDevIndexRouteImport } from './routes/_authed/dev/index'
import { Route as AuthedAgentsIndexRouteImport } from './routes/_authed/agents/index'
import { Route as AuthedWikiNewRouteImport } from './routes/_authed/wiki/new'
import { Route as AuthedWikiArticleIdRouteImport } from './routes/_authed/wiki/$articleId'
import { Route as AuthedSettingsUsersRouteImport } from './routes/_authed/settings/users'
import { Route as AuthedSettingsTagsRouteImport } from './routes/_authed/settings/tags'
import { Route as AuthedSettingsRolesRouteImport } from './routes/_authed/settings/roles'
import { Route as AuthedSettingsProfileRouteImport } from './routes/_authed/settings/profile'
import { Route as AuthedSettingsLogsRouteImport } from './routes/_authed/settings/logs'
import { Route as AuthedSettingsApiKeysRouteImport } from './routes/_authed/settings/api-keys'
import { Route as AuthedReportsManagersRouteImport } from './routes/_authed/reports/managers'
import { Route as AuthedReportsConversationsRouteImport } from './routes/_authed/reports/conversations'
import { Route as AuthedAgentsNewRouteImport } from './routes/_authed/agents/new'
import { Route as AuthedAgentsAgentIdRouteImport } from './routes/_authed/agents/$agentId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWabaRoute = AuthedWabaRouteImport.update({
  id: '/waba',
  path: '/waba',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTarefasRoute = AuthedTarefasRouteImport.update({
  id: '/tarefas',
  path: '/tarefas',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSelfServiceRoute = AuthedSelfServiceRouteImport.update({
  id: '/self-service',
  path: '/self-service',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPatiooRoute = AuthedPatiooRouteImport.update({
  id: '/patioo',
  path: '/patioo',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFinanceiroRoute = AuthedFinanceiroRouteImport.update({
  id: '/financeiro',
  path: '/financeiro',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEstoqueRoute = AuthedEstoqueRouteImport.update({
  id: '/estoque',
  path: '/estoque',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDevRoute = AuthedDevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentsRoute = AuthedAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWikiIndexRoute = AuthedWikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDevIndexRoute = AuthedDevIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedDevRoute,
} as any)
const AuthedAgentsIndexRoute = AuthedAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAgentsRoute,
} as any)
const AuthedWikiNewRoute = AuthedWikiNewRouteImport.update({
  id: '/wiki/new',
  path: '/wiki/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWikiArticleIdRoute = AuthedWikiArticleIdRouteImport.update({
  id: '/wiki/$articleId',
  path: '/wiki/$articleId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsUsersRoute = AuthedSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsTagsRoute = AuthedSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsRolesRoute = AuthedSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsProfileRoute = AuthedSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsLogsRoute = AuthedSettingsLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsApiKeysRoute = AuthedSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedReportsManagersRoute = AuthedReportsManagersRouteImport.update({
  id: '/managers',
  path: '/managers',
  getParentRoute: () => AuthedReportsRoute,
} as any)
const AuthedReportsConversationsRoute =
  AuthedReportsConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AuthedReportsRoute,
  } as any)
const AuthedAgentsNewRoute = AuthedAgentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedAgentsRoute,
} as any)
const AuthedAgentsAgentIdRoute = AuthedAgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AuthedAgentsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/agents': typeof AuthedAgentsRouteWithChildren
  '/dev': typeof AuthedDevRouteWithChildren
  '/estoque': typeof AuthedEstoqueRoute
  '/financeiro': typeof AuthedFinanceiroRoute
  '/patioo': typeof AuthedPatiooRoute
  '/reports': typeof AuthedReportsRouteWithChildren
  '/self-service': typeof AuthedSelfServiceRoute
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/tarefas': typeof AuthedTarefasRoute
  '/waba': typeof AuthedWabaRoute
  '/agents/$agentId': typeof AuthedAgentsAgentIdRoute
  '/agents/new': typeof AuthedAgentsNewRoute
  '/reports/conversations': typeof AuthedReportsConversationsRoute
  '/reports/managers': typeof AuthedReportsManagersRoute
  '/settings/api-keys': typeof AuthedSettingsApiKeysRoute
  '/settings/logs': typeof AuthedSettingsLogsRoute
  '/settings/profile': typeof AuthedSettingsProfileRoute
  '/settings/roles': typeof AuthedSettingsRolesRoute
  '/settings/tags': typeof AuthedSettingsTagsRoute
  '/settings/users': typeof AuthedSettingsUsersRoute
  '/wiki/$articleId': typeof AuthedWikiArticleIdRoute
  '/wiki/new': typeof AuthedWikiNewRoute
  '/agents/': typeof AuthedAgentsIndexRoute
  '/dev/': typeof AuthedDevIndexRoute
  '/wiki/': typeof AuthedWikiIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/estoque': typeof AuthedEstoqueRoute
  '/financeiro': typeof AuthedFinanceiroRoute
  '/patioo': typeof AuthedPatiooRoute
  '/reports': typeof AuthedReportsRouteWithChildren
  '/self-service': typeof AuthedSelfServiceRoute
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/tarefas': typeof AuthedTarefasRoute
  '/waba': typeof AuthedWabaRoute
  '/': typeof AuthedIndexRoute
  '/agents/$agentId': typeof AuthedAgentsAgentIdRoute
  '/agents/new': typeof AuthedAgentsNewRoute
  '/reports/conversations': typeof AuthedReportsConversationsRoute
  '/reports/managers': typeof AuthedReportsManagersRoute
  '/settings/api-keys': typeof AuthedSettingsApiKeysRoute
  '/settings/logs': typeof AuthedSettingsLogsRoute
  '/settings/profile': typeof AuthedSettingsProfileRoute
  '/settings/roles': typeof AuthedSettingsRolesRoute
  '/settings/tags': typeof AuthedSettingsTagsRoute
  '/settings/users': typeof AuthedSettingsUsersRoute
  '/wiki/$articleId': typeof AuthedWikiArticleIdRoute
  '/wiki/new': typeof AuthedWikiNewRoute
  '/agents': typeof AuthedAgentsIndexRoute
  '/dev': typeof AuthedDevIndexRoute
  '/wiki': typeof AuthedWikiIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/agents': typeof AuthedAgentsRouteWithChildren
  '/_authed/dev': typeof AuthedDevRouteWithChildren
  '/_authed/estoque': typeof AuthedEstoqueRoute
  '/_authed/financeiro': typeof AuthedFinanceiroRoute
  '/_authed/patioo': typeof AuthedPatiooRoute
  '/_authed/reports': typeof AuthedReportsRouteWithChildren
  '/_authed/self-service': typeof AuthedSelfServiceRoute
  '/_authed/settings': typeof AuthedSettingsRouteWithChildren
  '/_authed/tarefas': typeof AuthedTarefasRoute
  '/_authed/waba': typeof AuthedWabaRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/agents/$agentId': typeof AuthedAgentsAgentIdRoute
  '/_authed/agents/new': typeof AuthedAgentsNewRoute
  '/_authed/reports/conversations': typeof AuthedReportsConversationsRoute
  '/_authed/reports/managers': typeof AuthedReportsManagersRoute
  '/_authed/settings/api-keys': typeof AuthedSettingsApiKeysRoute
  '/_authed/settings/logs': typeof AuthedSettingsLogsRoute
  '/_authed/settings/profile': typeof AuthedSettingsProfileRoute
  '/_authed/settings/roles': typeof AuthedSettingsRolesRoute
  '/_authed/settings/tags': typeof AuthedSettingsTagsRoute
  '/_authed/settings/users': typeof AuthedSettingsUsersRoute
  '/_authed/wiki/$articleId': typeof AuthedWikiArticleIdRoute
  '/_authed/wiki/new': typeof AuthedWikiNewRoute
  '/_authed/agents/': typeof AuthedAgentsIndexRoute
  '/_authed/dev/': typeof AuthedDevIndexRoute
  '/_authed/wiki/': typeof AuthedWikiIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/agents'
    | '/dev'
    | '/estoque'
    | '/financeiro'
    | '/patioo'
    | '/reports'
    | '/self-service'
    | '/settings'
    | '/tarefas'
    | '/waba'
    | '/agents/$agentId'
    | '/agents/new'
    | '/reports/conversations'
    | '/reports/managers'
    | '/settings/api-keys'
    | '/settings/logs'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/tags'
    | '/settings/users'
    | '/wiki/$articleId'
    | '/wiki/new'
    | '/agents/'
    | '/dev/'
    | '/wiki/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/estoque'
    | '/financeiro'
    | '/patioo'
    | '/reports'
    | '/self-service'
    | '/settings'
    | '/tarefas'
    | '/waba'
    | '/'
    | '/agents/$agentId'
    | '/agents/new'
    | '/reports/conversations'
    | '/reports/managers'
    | '/settings/api-keys'
    | '/settings/logs'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/tags'
    | '/settings/users'
    | '/wiki/$articleId'
    | '/wiki/new'
    | '/agents'
    | '/dev'
    | '/wiki'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/agents'
    | '/_authed/dev'
    | '/_authed/estoque'
    | '/_authed/financeiro'
    | '/_authed/patioo'
    | '/_authed/reports'
    | '/_authed/self-service'
    | '/_authed/settings'
    | '/_authed/tarefas'
    | '/_authed/waba'
    | '/_authed/'
    | '/_authed/agents/$agentId'
    | '/_authed/agents/new'
    | '/_authed/reports/conversations'
    | '/_authed/reports/managers'
    | '/_authed/settings/api-keys'
    | '/_authed/settings/logs'
    | '/_authed/settings/profile'
    | '/_authed/settings/roles'
    | '/_authed/settings/tags'
    | '/_authed/settings/users'
    | '/_authed/wiki/$articleId'
    | '/_authed/wiki/new'
    | '/_authed/agents/'
    | '/_authed/dev/'
    | '/_authed/wiki/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/waba': {
      id: '/_authed/waba'
      path: '/waba'
      fullPath: '/waba'
      preLoaderRoute: typeof AuthedWabaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tarefas': {
      id: '/_authed/tarefas'
      path: '/tarefas'
      fullPath: '/tarefas'
      preLoaderRoute: typeof AuthedTarefasRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/self-service': {
      id: '/_authed/self-service'
      path: '/self-service'
      fullPath: '/self-service'
      preLoaderRoute: typeof AuthedSelfServiceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/patioo': {
      id: '/_authed/patioo'
      path: '/patioo'
      fullPath: '/patioo'
      preLoaderRoute: typeof AuthedPatiooRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/financeiro': {
      id: '/_authed/financeiro'
      path: '/financeiro'
      fullPath: '/financeiro'
      preLoaderRoute: typeof AuthedFinanceiroRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/estoque': {
      id: '/_authed/estoque'
      path: '/estoque'
      fullPath: '/estoque'
      preLoaderRoute: typeof AuthedEstoqueRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dev': {
      id: '/_authed/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof AuthedDevRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agents': {
      id: '/_authed/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthedAgentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/wiki/': {
      id: '/_authed/wiki/'
      path: '/wiki'
      fullPath: '/wiki/'
      preLoaderRoute: typeof AuthedWikiIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dev/': {
      id: '/_authed/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof AuthedDevIndexRouteImport
      parentRoute: typeof AuthedDevRoute
    }
    '/_authed/agents/': {
      id: '/_authed/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthedAgentsIndexRouteImport
      parentRoute: typeof AuthedAgentsRoute
    }
    '/_authed/wiki/new': {
      id: '/_authed/wiki/new'
      path: '/wiki/new'
      fullPath: '/wiki/new'
      preLoaderRoute: typeof AuthedWikiNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/wiki/$articleId': {
      id: '/_authed/wiki/$articleId'
      path: '/wiki/$articleId'
      fullPath: '/wiki/$articleId'
      preLoaderRoute: typeof AuthedWikiArticleIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/users': {
      id: '/_authed/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthedSettingsUsersRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/tags': {
      id: '/_authed/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthedSettingsTagsRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/roles': {
      id: '/_authed/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthedSettingsRolesRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/profile': {
      id: '/_authed/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthedSettingsProfileRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/logs': {
      id: '/_authed/settings/logs'
      path: '/logs'
      fullPath: '/settings/logs'
      preLoaderRoute: typeof AuthedSettingsLogsRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/api-keys': {
      id: '/_authed/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthedSettingsApiKeysRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/reports/managers': {
      id: '/_authed/reports/managers'
      path: '/managers'
      fullPath: '/reports/managers'
      preLoaderRoute: typeof AuthedReportsManagersRouteImport
      parentRoute: typeof AuthedReportsRoute
    }
    '/_authed/reports/conversations': {
      id: '/_authed/reports/conversations'
      path: '/conversations'
      fullPath: '/reports/conversations'
      preLoaderRoute: typeof AuthedReportsConversationsRouteImport
      parentRoute: typeof AuthedReportsRoute
    }
    '/_authed/agents/new': {
      id: '/_authed/agents/new'
      path: '/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AuthedAgentsNewRouteImport
      parentRoute: typeof AuthedAgentsRoute
    }
    '/_authed/agents/$agentId': {
      id: '/_authed/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthedAgentsAgentIdRouteImport
      parentRoute: typeof AuthedAgentsRoute
    }
  }
}

interface AuthedAgentsRouteChildren {
  AuthedAgentsAgentIdRoute: typeof AuthedAgentsAgentIdRoute
  AuthedAgentsNewRoute: typeof AuthedAgentsNewRoute
  AuthedAgentsIndexRoute: typeof AuthedAgentsIndexRoute
}

const AuthedAgentsRouteChildren: AuthedAgentsRouteChildren = {
  AuthedAgentsAgentIdRoute: AuthedAgentsAgentIdRoute,
  AuthedAgentsNewRoute: AuthedAgentsNewRoute,
  AuthedAgentsIndexRoute: AuthedAgentsIndexRoute,
}

const AuthedAgentsRouteWithChildren = AuthedAgentsRoute._addFileChildren(
  AuthedAgentsRouteChildren,
)

interface AuthedDevRouteChildren {
  AuthedDevIndexRoute: typeof AuthedDevIndexRoute
}

const AuthedDevRouteChildren: AuthedDevRouteChildren = {
  AuthedDevIndexRoute: AuthedDevIndexRoute,
}

const AuthedDevRouteWithChildren = AuthedDevRoute._addFileChildren(
  AuthedDevRouteChildren,
)

interface AuthedReportsRouteChildren {
  AuthedReportsConversationsRoute: typeof AuthedReportsConversationsRoute
  AuthedReportsManagersRoute: typeof AuthedReportsManagersRoute
}

const AuthedReportsRouteChildren: AuthedReportsRouteChildren = {
  AuthedReportsConversationsRoute: AuthedReportsConversationsRoute,
  AuthedReportsManagersRoute: AuthedReportsManagersRoute,
}

const AuthedReportsRouteWithChildren = AuthedReportsRoute._addFileChildren(
  AuthedReportsRouteChildren,
)

interface AuthedSettingsRouteChildren {
  AuthedSettingsApiKeysRoute: typeof AuthedSettingsApiKeysRoute
  AuthedSettingsLogsRoute: typeof AuthedSettingsLogsRoute
  AuthedSettingsProfileRoute: typeof AuthedSettingsProfileRoute
  AuthedSettingsRolesRoute: typeof AuthedSettingsRolesRoute
  AuthedSettingsTagsRoute: typeof AuthedSettingsTagsRoute
  AuthedSettingsUsersRoute: typeof AuthedSettingsUsersRoute
}

const AuthedSettingsRouteChildren: AuthedSettingsRouteChildren = {
  AuthedSettingsApiKeysRoute: AuthedSettingsApiKeysRoute,
  AuthedSettingsLogsRoute: AuthedSettingsLogsRoute,
  AuthedSettingsProfileRoute: AuthedSettingsProfileRoute,
  AuthedSettingsRolesRoute: AuthedSettingsRolesRoute,
  AuthedSettingsTagsRoute: AuthedSettingsTagsRoute,
  AuthedSettingsUsersRoute: AuthedSettingsUsersRoute,
}

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(
  AuthedSettingsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAgentsRoute: typeof AuthedAgentsRouteWithChildren
  AuthedDevRoute: typeof AuthedDevRouteWithChildren
  AuthedEstoqueRoute: typeof AuthedEstoqueRoute
  AuthedFinanceiroRoute: typeof AuthedFinanceiroRoute
  AuthedPatiooRoute: typeof AuthedPatiooRoute
  AuthedReportsRoute: typeof AuthedReportsRouteWithChildren
  AuthedSelfServiceRoute: typeof AuthedSelfServiceRoute
  AuthedSettingsRoute: typeof AuthedSettingsRouteWithChildren
  AuthedTarefasRoute: typeof AuthedTarefasRoute
  AuthedWabaRoute: typeof AuthedWabaRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedWikiArticleIdRoute: typeof AuthedWikiArticleIdRoute
  AuthedWikiNewRoute: typeof AuthedWikiNewRoute
  AuthedWikiIndexRoute: typeof AuthedWikiIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAgentsRoute: AuthedAgentsRouteWithChildren,
  AuthedDevRoute: AuthedDevRouteWithChildren,
  AuthedEstoqueRoute: AuthedEstoqueRoute,
  AuthedFinanceiroRoute: AuthedFinanceiroRoute,
  AuthedPatiooRoute: AuthedPatiooRoute,
  AuthedReportsRoute: AuthedReportsRouteWithChildren,
  AuthedSelfServiceRoute: AuthedSelfServiceRoute,
  AuthedSettingsRoute: AuthedSettingsRouteWithChildren,
  AuthedTarefasRoute: AuthedTarefasRoute,
  AuthedWabaRoute: AuthedWabaRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedWikiArticleIdRoute: AuthedWikiArticleIdRoute,
  AuthedWikiNewRoute: AuthedWikiNewRoute,
  AuthedWikiIndexRoute: AuthedWikiIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
